class Orphans {
    constructor(container) {
        this.container = container;

        this.settings = {
            exceptions: [
                'dn.'
            ]
        };

        this.container.innerHTML = this.removeOrphans(this.container.innerHTML);
    }

    checkWord(currentWord, words, i) {
        if (currentWord.length <= 2 || this.settings.exceptions.indexOf(currentWord.toLowerCase()) !== -1) {
            words[i + 1] = currentWord + '&nbsp;' + words[i + 1];
            words.splice(i, 1);
        }

        return words;
    }

    removeOrphans(data) {
        if (typeof data === 'string') {
            let words = data.replace(/\s+/g, ' ').trim().split(' '),
                isTag = false;

            for (let i = words.length - 2, l = 0; i > l; i--) {
                const currentWord = words[i];

                if (isTag) {
                    if (currentWord.indexOf('>')) {
                        isTag = false;
                        // TODO: pewnie trzeba tez obsluzyc wystepowanie zamkniecia nawiasu w srodku slowa
                    }
                } else {
                    if (currentWord[0] === '<') {
                        isTag = true;
                    } else {
                        words = this.checkWord(currentWord, words, i);
                    }
                }
            }

            data = words.join(' ');
        }

        return data;
    }
}

export default Orphans;
